module.exports = __webpack_public_path__ + "img/logo-blue.d0331af1.svg";